import React, { useEffect, useContext } from "react";

// Contexts
import { DataContext } from "contexts/Data";

// External components
// import Tilt from "react-parallax-tilt";

const Needle = () => {
    const { isTouch } = useContext(DataContext);

    // Move needle
    useEffect(() => {
        // Create needle
        let wrapper = document.getElementById("needle-container");
        let needle = document.createElement("img");
        let needleShadow = document.createElement("img");
        needle.id = "needle";
        needleShadow.id = "needle-shadow";
        needle.src = process.env.PUBLIC_URL + "/images/needle.png";
        needleShadow.src = process.env.PUBLIC_URL + "/images/needle.png";
        wrapper.appendChild(needle);
        wrapper.appendChild(needleShadow);
    }, []);
    useEffect(() => {
        let needleDOM = document.getElementById("needle");
        let needleShadowDOM = document.getElementById("needle-shadow");
        if (!isTouch) {
            needleDOM.classList.remove("needle--notouch");
            needleShadowDOM.classList.remove("needle--notouch");
            if (needleDOM) {
                const onMouseMove = (e) => {
                    needleDOM.style.transform = `translate(-40%, -90%) rotate(${
                        (e.pageY + e.pageX) / 10
                    }deg) scale(${(e.pageX + e.pageY) / 1000})
          
                `;
                    needleDOM.style.left = e.pageX + "px";
                    needleDOM.style.top = e.pageY + "px";
                };
                document.addEventListener("mousemove", onMouseMove);
            }

            if (needleShadowDOM) {
                const onMouseMove = (e) => {
                    needleShadowDOM.style.transform = `translate(-40%, -90%) rotate(${
                        (e.pageY + e.pageX) / 9.8
                    }deg) scale(${(e.pageX + e.pageY) / 1000})
          
                `;
                    needleShadowDOM.style.left = e.pageX + "px";
                    needleShadowDOM.style.top = e.pageY + "px";
                };
                document.addEventListener("mousemove", onMouseMove);
            }
        } else {
            needleDOM.classList.add("needle--notouch");
            needleShadowDOM.classList.add("needle--notouch");
        }
    }, [isTouch]);
    return <div id="needle-container"></div>;
};

export default Needle;
